import PropTypes from 'prop-types';

const ClientCategory = {
  id: PropTypes.number,
  labelEn: PropTypes.string.isRequired,
  labelFr: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
  confirm: PropTypes.bool,
  icon: PropTypes.string,
};

export const ClientCategoryShape = PropTypes.shape(ClientCategory);
export const ClientCategoryExact = PropTypes.exact(ClientCategory);
